import(/* webpackMode: "eager" */ "/vercel/path0/src/app/not-found.js");
